import { usePerformanceMeasureDefinition } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { CatalogDefinition, QuestionnaireEdit } from "@/features/catalog";
import { questionnaireDefinitionUrlFromRouteId } from "@/features/catalog/lib/questionnaire-definition-route";

export const Route = createFileRoute("/catalog/performance-measures/$questionnaireId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("Questionnaire")) {
      throw redirect({ to: "/catalog/performance-measures" });
    }
  },
  component: EditQuestionnaireComponent,
});

function EditQuestionnaireComponent() {
  const { questionnaireId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const questionnaire = usePerformanceMeasureDefinition(questionnaireDefinitionUrlFromRouteId(questionnaireId));

  if (!questionnaire) {
    return (
      <CatalogDefinition.NotFound
        label="Performance measure"
        backTo="/catalog/performance-measures"
        backLabel="Back to performance measures"
      />
    );
  }

  return (
    <QuestionnaireEdit
      performance
      key={questionnaireId}
      questionnaire={questionnaire}
      canEdit={permissions.canWrite("Questionnaire")}
      onDone={() => navigate({ to: "/catalog/performance-measures" })}
      onCancel={() => navigate({ to: "/catalog/performance-measures/$questionnaireId", params: { questionnaireId } })}
    />
  );
}
